import { useEffect, useState } from "react";
import { Loader2, Lock, Crown, Gift, ExternalLink } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { REDEEM_URL } from "@/config/social";
import { useAuth } from "@/context/AuthContext";
import { QuizCard } from "@/components/QuizCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const WELCOME_TEXT =
  "SE SEI QUI HAI DIRITTO AD ENTRARE ALL'INTERNO DEL NOSTRO GRUPPO PRIVATO DOVE TROVERAI LE GIOCATE PIÙ ESCLUSIVE E TANTE FANTASTICHE NOVITÀ. INOLTRE PUOI DIRE LA TUA NEL GRUPPO ED ESULTARE INSIEME A TONY. BAND E FESS";

export default function Vip() {
  const [status, setStatus] = useState(null);
  useEffect(() => { api.get("/vip/status").then((r) => setStatus(r.data)); }, []);

  if (!status) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;
  if (!status.is_vip) return <VipLocked />;
  return <VipContent status={status} />;
}

function VipLocked() {
  return (
    <div data-testid="vip-locked" className="mx-auto max-w-md space-y-5 py-6 text-center">
      <div className="flex justify-center">
        <div className="flex h-24 w-24 items-center justify-center rounded-full border-2 border-zinc-950 bg-zinc-950">
          <Lock className="h-12 w-12 text-green-400" />
        </div>
      </div>
      <p data-testid="vip-locked-text" className="font-display text-2xl font-black uppercase leading-tight text-zinc-950">
        NON SEI ANCORA NEL VIP<br />NIENTE PAURA SCRIVIMI QUI SOTTO
      </p>
      <a data-testid="vip-cta-join" href={REDEEM_URL} target="_blank" rel="noopener noreferrer"
        className="flex w-full items-center justify-center gap-2 rounded-full bg-green-500 py-4 text-base font-black uppercase tracking-wide text-zinc-950 transition-colors hover:bg-green-400">
        VOGLIO ENTRARE NEL VIP
      </a>
      <div className="rounded-3xl border-2 border-zinc-950 bg-green-500/10 p-5 text-left">
        <p className="flex items-center gap-2 font-display text-lg font-black uppercase text-zinc-950">
          <Gift className="h-5 w-5 text-green-500" /> Cosa troverai all'interno del VIP
        </p>
        <ul className="mt-4 space-y-4">
          <li className="flex gap-3">
            <span className="text-xl leading-none">🏆</span>
            <p className="text-sm leading-relaxed text-zinc-700">
              <span className="font-black text-zinc-950">Premi esclusivi:</span> nella sezione VIP il gioco non cambia,
              rispondi sempre ai pronostici gratis e accumuli punti. Cambiano i premi: Tony mette in palio premi
              esclusivi e non solo, come esperienze fantastiche in tutti gli stadi d'Italia, con biglietti VIP e tanto altro.
            </p>
          </li>
          <li className="flex gap-3">
            <span className="text-xl leading-none">💬</span>
            <p className="text-sm leading-relaxed text-zinc-700">
              <span className="font-black text-zinc-950">Gruppo esclusivo BAND E FESS:</span> accesso al gruppo privato
              dove ricevi notizie e pronostici esclusivi.
            </p>
          </li>
          <li className="flex gap-3">
            <span className="text-xl leading-none">🗣️</span>
            <p className="text-sm leading-relaxed text-zinc-700">
              <span className="font-black text-zinc-950">Chat insieme a Tony:</span> puoi parlare e interagire
              direttamente con Tony.
            </p>
          </li>
          <li className="flex gap-3">
            <span className="text-xl leading-none">📊</span>
            <p className="text-sm leading-relaxed text-zinc-700">
              <span className="font-black text-zinc-950">Classifiche e pronostici riservati:</span> solo per gli utenti
              VIP, separati da quelli della sezione pubblica.
            </p>
          </li>
        </ul>
        <p className="mt-5 text-center text-sm font-bold text-zinc-950">Vuoi entrare? Premi il bottone e scrivimi!</p>
        <a data-testid="vip-cta-join-bottom" href={REDEEM_URL} target="_blank" rel="noopener noreferrer"
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-full bg-green-500 py-4 text-base font-black uppercase tracking-wide text-zinc-950 transition-colors hover:bg-green-400">
          VOGLIO ENTRARE NEL VIP
        </a>
      </div>
    </div>
  );
}

function VipContent({ status }) {
  return (
    <div className="space-y-6">
      {/* Welcome block */}
      <section data-testid="vip-welcome-block" className="overflow-hidden rounded-3xl border-2 border-yellow-400 bg-zinc-950 p-6 text-center shadow-[6px_6px_0_0_#facc15]">
        <div className="flex justify-center">
          {status.group_logo ? (
            <img data-testid="vip-group-logo" src={fileUrl(status.group_logo)} alt="Gruppo privato" className="h-28 w-28 rounded-2xl object-contain" />
          ) : (
            <div className="flex h-24 w-24 items-center justify-center rounded-2xl bg-yellow-400">
              <Crown className="h-12 w-12 text-zinc-950" />
            </div>
          )}
        </div>
        <p className="mt-4 text-sm font-bold uppercase leading-relaxed tracking-tight text-white">{WELCOME_TEXT}</p>
        <a data-testid="vip-group-cta" href={status.group_link} target="_blank" rel="noopener noreferrer"
          className="mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-yellow-400 py-4 text-base font-black uppercase tracking-wide text-zinc-950 transition-colors hover:bg-yellow-300">
          <ExternalLink className="h-5 w-5" /> ENTRA NEL GRUPPO PRIVATO
        </a>
      </section>

      <Tabs defaultValue="preds">
        <TabsList className="grid w-full grid-cols-2 gap-2 bg-transparent p-0">
          <TabsTrigger data-testid="vip-tab-preds" value="preds" className="rounded-full border border-slate-200 bg-white py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-yellow-400">Pronostici VIP</TabsTrigger>
          <TabsTrigger data-testid="vip-tab-board" value="board" className="rounded-full border border-slate-200 bg-white py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-yellow-400">Classifiche VIP</TabsTrigger>
        </TabsList>
        <TabsContent value="preds" className="mt-5"><VipPredictions /></TabsContent>
        <TabsContent value="board" className="mt-5"><VipLeaderboard /></TabsContent>
      </Tabs>
    </div>
  );
}

function VipPredictions() {
  const [preds, setPreds] = useState(null);
  const load = () => api.get("/vip/predictions/active").then((r) => setPreds(r.data));
  useEffect(() => { load(); }, []);
  if (preds === null) return <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;
  if (preds.length === 0) return (
    <div className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-10 text-center">
      <p className="font-display text-xl font-bold uppercase text-zinc-400">Nessun pronostico VIP attivo</p>
      <p className="mt-1 text-sm text-zinc-500">Torna presto per le giocate più esclusive!</p>
    </div>
  );
  return <div className="grid gap-5 md:grid-cols-2">{preds.map((p) => <QuizCard key={p.id} pred={p} onAnswered={load} />)}</div>;
}

function VipLeaderboard() {
  const { user } = useAuth();
  const [periods, setPeriods] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/vip/periods/all").then((r) => {
      const active = (r.data || []).filter((p) => p.status === "active");
      setPeriods(active);
      setSelectedId(active.length ? active[0].id : "");
    });
  }, []);
  useEffect(() => {
    if (selectedId === null) return;
    setData(null);
    api.get(selectedId ? `/vip/leaderboard?period_id=${selectedId}` : "/vip/leaderboard").then((r) => setData(r.data));
  }, [selectedId]);

  if (!periods) return <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;
  const rows = data?.rows || [];
  return (
    <div className="space-y-5">
      {periods.length > 1 && (
        <div data-testid="vip-classifiche-selector" className="flex gap-2 overflow-x-auto pb-1">
          {periods.map((p) => (
            <button key={p.id} data-testid={`vip-classifica-chip-${p.id}`} onClick={() => setSelectedId(p.id)}
              className={`shrink-0 rounded-full border-2 px-4 py-2 text-sm font-black uppercase tracking-tight transition-colors ${selectedId === p.id ? "border-zinc-950 bg-zinc-950 text-yellow-400" : "border-slate-200 bg-white text-zinc-600"}`}>
              {p.name}
            </button>
          ))}
        </div>
      )}
      {data?.period && (
        <div className="overflow-hidden rounded-3xl border-2 border-yellow-400 bg-zinc-950 text-white">
          {data.period.prize_image && <img src={fileUrl(data.period.prize_image)} alt="" className="h-40 w-full object-cover" />}
          <div className="p-5">
            <p className="font-display text-xl font-black uppercase">{data.period.name}</p>
            {data.period.prize ? (
              <>
                <p className="mt-1 flex items-center gap-2 text-sm text-zinc-300"><Gift className="h-4 w-4 text-yellow-400" /> In palio: <span className="font-bold text-white">{data.period.prize}</span></p>
                <a data-testid="vip-riscatta-premio-btn" href={REDEEM_URL} target="_blank" rel="noopener noreferrer"
                  className="mt-4 flex w-full items-center justify-center rounded-full bg-yellow-400 py-3 text-sm font-black uppercase tracking-wide text-zinc-950 hover:bg-yellow-300">
                  Riscatta il tuo premio
                </a>
              </>
            ) : <p className="mt-1 text-sm text-zinc-400">Premio non ancora annunciato.</p>}
          </div>
        </div>
      )}
      {!data ? (
        <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-green-500" /></div>
      ) : rows.length === 0 ? (
        <div className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-10 text-center text-zinc-500">Ancora nessun punto assegnato.</div>
      ) : (
        <div data-testid="vip-leaderboard-list" className="overflow-hidden rounded-3xl border border-slate-200 bg-white">
          <div className="grid grid-cols-[2rem_1fr_2.6rem_2.4rem_2.4rem_3rem] items-center gap-1 bg-zinc-950 px-3 py-2.5 text-[9px] font-black uppercase tracking-wide text-yellow-400">
            <span>#</span><span>Giocatore</span><span className="text-center">Gioc.</span><span className="text-center">✓</span><span className="text-center">✗</span><span className="text-right">Punti</span>
          </div>
          {rows.map((r) => (
            <div key={r.user_id} data-testid={`vip-leaderboard-row-${r.rank}`}
              className={`grid grid-cols-[2rem_1fr_2.6rem_2.4rem_2.4rem_3rem] items-center gap-1 border-b border-slate-100 px-3 py-2.5 last:border-0 ${r.username === user?.username ? "bg-yellow-50" : ""}`}>
              <span className={`font-mono-t text-sm font-black ${r.rank === 1 ? "text-yellow-500" : r.rank === 2 ? "text-slate-400" : r.rank === 3 ? "text-amber-600" : "text-zinc-400"}`}>{r.rank}</span>
              <span className="truncate font-semibold text-zinc-900">{r.username}</span>
              <span className="text-center font-mono-t text-sm font-bold text-zinc-600">{r.answered}</span>
              <span className="text-center font-mono-t text-sm font-bold text-green-600">{r.correct}</span>
              <span className="text-center font-mono-t text-sm font-bold text-red-500">{r.wrong}</span>
              <span className="text-right font-mono-t text-sm font-black text-zinc-950">{r.points}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
